/**
 * Designed  & Developed by Faisal Nadaf
 * Contact: faisalfnadaf@gmail.com
 *
 * @format
 */

import { Navigation } from "@/components/customCopmonent/landingSection/navigation";
import { FooterSection } from "@/components/customCopmonent/landingSection/footer-section";
import CircularGallery from "@/components/customCopmonent/CircularGallery";
import DotGrid from "@/components/customCopmonent/DotGrid";
import { PageHeaderHero, PAGE_HERO_CLASS } from "@/components/customCopmonent/Text/PageHeaderHero";
import { SectionWrapper } from "../Clientele.page-primitives";
import { PageHeader } from "@/components/customCopmonent/Text/PageHeader";
import { RevealOnScroll } from "@/components/SpecialProjectsPage.primitives";
import Seo from "@/components/Seo";
import { useIsMobile } from "@/hooks/hooks/use-mobile";

import React, { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import {
	IndustrySectionProduct,
	IndustrySectionApplication,
} from "@/components/customCopmonent/IndustryCardsAP";

// Register ScrollTrigger
if (typeof window !== "undefined") {
	gsap.registerPlugin(ScrollTrigger);
}

const SUB_INDUSTRY_IMAGES = [
	"/images/industriesPhotos/Marine&Offshore/SubIndustries/Offshore_Oil_Platforms.webp",
	"/images/industriesPhotos/Marine&Offshore/SubIndustries/FPSO_Units.webp",
	"/images/industriesPhotos/Marine&Offshore/SubIndustries/Shipbuilding_Yards.webp",
	"/images/industriesPhotos/Marine&Offshore/SubIndustries/Naval_Vessels.webp",
	"/images/industriesPhotos/Marine&Offshore/SubIndustries/Commercial_Ships.webp",
	"/images/industriesPhotos/Marine&Offshore/SubIndustries/Offshore_Processing_Facilities.webp",
];

const APPLICATION_IMAGES = [
	"/images/industriesPhotos/Marine&Offshore/Application/Seawater_Cooling_Systems.webp",
	"/images/industriesPhotos/Marine&Offshore/Application/Engine_Jacket_Water_Cooling.webp",
	"/images/industriesPhotos/Marine&Offshore/Application/Lube_Oil_Cooling.jpg",
	"/images/industriesPhotos/Marine&Offshore/Application/Offshore_Process_Cooling.webp",
	"/images/industriesPhotos/Marine&Offshore/Application/Condensation_Systems.webp",
	"/images/industriesPhotos/Marine&Offshore/SubIndustries/Commercial_Ships.webp",
];

const MarineOffshore = () => {
	const { t } = useTranslation();
	const isMobile = useIsMobile();

	const subIndustryTexts = t(
		"industryPages.marineOffshore.subIndustries.items",
		{ returnObjects: true },
	) as string[];
	const applicationItems = t("industryPages.marineOffshore.applications.items", {
		returnObjects: true,
	}) as { title: string; description: string }[];

	const pageData = {
		title: t("industryPages.marineOffshore.title"),
		bgimage: "/images/header/marien1.webp",
		description: t("industryPages.marineOffshore.tagline"),
		meta: t("industryPages.marineOffshore.meta", {
			returnObjects: true,
		}) as string[],
		subIndustries: {
			title: t("industryPages.marineOffshore.subIndustries.title"),
			industries: SUB_INDUSTRY_IMAGES.map((image, i) => ({
				image,
				text: subIndustryTexts[i],
			})),
		},
		applications: {
			title: t("industryPages.marineOffshore.applications.title"),
			applications: APPLICATION_IMAGES.map((image, i) => ({
				image,
				title: applicationItems[i]?.title,
				description: applicationItems[i]?.description,
			})),
		},
	};

	return (
		<>
			<Seo
				titleKey="industryPages.marineOffshore.seo.title"
				descriptionKey="industryPages.marineOffshore.seo.description"
				path="/industries/marine-offshore"
			/>
			<Navigation />
			<SectionWrapper className={PAGE_HERO_CLASS}>
				<div className="absolute inset-0 ">
					{" "}
					<div
						className="absolute bottom-3 inset-0 opacity-35 scale-105"
						style={{
							backgroundImage: `url(${pageData.bgimage})`,
							backgroundSize: "cover",
							backgroundPosition: "center",
						}}
					/>
					<DotGrid
						dotSize={4}
						gap={15}
						baseColor="#3b0092"
						activeColor="#f09a38"
						proximity={100}
						shockRadius={200}
						shockStrength={3}
						resistance={750}
						returnDuration={1.5}
					/>
				</div>
				<PageHeaderHero
					// align="center"
					title={pageData.title}
					description={pageData.description}
					meta={pageData.meta}
				/>
			</SectionWrapper>
			<SectionWrapper
				className="pt-0  !px-0 !max-w-none"
				contentClassName="!max-w-none !px-0">
				{" "}
				<div className="relative flex flex-col items-center justify-center ">
					{/* ===== HEADER ===== */}
					<RevealOnScroll>
						<PageHeader
							title={pageData.subIndustries.title}
							align="center"
							className="py-6 text-center items-center "
						/>
					</RevealOnScroll>
				</div>
				<div className="relative h-[360px] sm:h-[460px] lg:h-[600px]">
					<CircularGallery
						items={pageData.subIndustries.industries}
						textColor="#000"
						borderRadius={0.05}
						bend={isMobile ? 0 : -3}
						scrollSpeed={1.5}
						scrollEase={0.05}
					/>
				</div>
			</SectionWrapper>
			<SectionWrapper
				className="pt-0  !px-0 !max-w-none"
				contentClassName="!max-w-none !px-0">
				<IndustrySectionApplication
					applications={pageData.applications.applications}
					title={pageData.applications.title}
				/>{" "}
			</SectionWrapper>
			{/* <SectionWrapper
				className="pt-0  !px-0 !max-w-none"
				contentClassName="!max-w-none !px-0">
				<IndustrySectionProduct
					applications={pageData.products.products}
					title={pageData.products.title}
					description={pageData.products.description}
				/>{" "}
			</SectionWrapper> */}
			<FooterSection />
		</>
	);
};

export default MarineOffshore;
